import styled, { css } from 'styled-components';

export const Content = styled.div`
  width: 590px;
  position: relative;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      width: 100%;
    `}
`;